import { CategoricalColumn, NumericalColumn } from 'baseui/data-table';

export const COL_NAMES = {
	minAppVersion: 'minAppVersion',
	maxAppVersion: 'maxAppVersion',
	bucket: 'bucket',
	layoutItemsCount: 'layoutItemCount'
};

export const columnConfigs = [
	NumericalColumn({
		title: 'minAppVersion',
		columnName: COL_NAMES.minAppVersion,
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.minAppVersion]
	}),
	NumericalColumn({
		title: 'maxAppVersion',
		columnName: COL_NAMES.maxAppVersion,
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.maxAppVersion]
	}),
	CategoricalColumn({
		title: 'bucket',
		columnName: COL_NAMES.bucket,
		maxWidth: 450,
		mapDataToValue: (data: any) => data[COL_NAMES.bucket]
	}),
	NumericalColumn({
		title: 'Layout Items Count',
		columnName: COL_NAMES.layoutItemsCount,
		maxWidth: 150,
		mapDataToValue: (data: any) => data[COL_NAMES.layoutItemsCount]
	})
];
